import styled from '@emotion/styled';
import { rgba } from 'emotion-rgba';
import { ThemeStyle } from '../theme';


export const RadioCheckBox = styled.span`
.control {
  display: block;
  position: relative;
  padding-top: 1px;
  padding-left: 30px;
  margin-bottom: 15px;
  cursor: pointer;
  font-size: 14px;
  /* Checkbox tick */
  &--checkbox {
    .control__indicator {
      &:after {
        left: 6px;
        top: 2px;
        width: 6px;
        height: 12px;
        border: solid ${({ theme }: ThemeStyle) => theme.white};;
        border-width: 0 2px 2px 0;
        // border-radius: 50%;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
      }
    }
  }

  /* Hover state */
  &:hover {
    input[type="checkbox"] {
      ~ .control__indicator {
        background: ${({ theme }: ThemeStyle) => theme.white};
      }

      &:not([disabled]) {
        &.checked {
          ~ .control__indicator {
            background: ${({ theme }: ThemeStyle) => theme.brandPrimary900};
            border-color: ${({ theme }: ThemeStyle) => theme.brandPrimary900};
          }
        }
      }
    }
  }

  /* Hover state whilst checked */

  input[type="checkbox"] {
    position: absolute;
    z-index: -1;
    opacity: 0;
    left: 0;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    /* Focus state */
    &:focus {
      ~ .control__indicator {
        background: ${({ theme }: ThemeStyle) => theme.white};
      }
    }

    /* Checked state */
    &.checked {
      ~ .control__indicator {
        background: ${({ theme }: ThemeStyle) => theme.brandPrimary900};
        border-color: ${({ theme }: ThemeStyle) => theme.brandPrimary900};
        /* Show check mark */
        &:after {
          display: block;
        }
      }

      &:focus {
        ~ .control__indicator {
          background: ${({ theme }: ThemeStyle) => theme.brandtextPrimaryColor};
          border-color: ${({ theme }: ThemeStyle) => theme.brandtextPrimaryColor};

        }
      }
    }

    /* Disabled tick colour */
    &:disabled {
      ~ .control__indicator {
        pointer-events: none;
        opacity: .6;
        background: ${({ theme }: ThemeStyle) => theme.grey.G2};

        &:after {
          border-color: ${({ theme }: ThemeStyle) => theme.grey.G7};
        }
      }
    }
  }


  .control__indicator {
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    border-radius: 2px;
    background: ${({ theme }: ThemeStyle) => rgba(theme.grey.G10, 0.08)};
    border: 1px solid ${({ theme }: ThemeStyle) => theme.grey.G5};
    border-radius: ${({borderRadius}: ThemeStyle) => borderRadius ? `${borderRadius}%`: '50%'};
    
    /* Check mark */
    &:after {
      position: absolute;
      display: none;
      content: '';
    }
  }
}
`;
